import { takeLatest } from 'redux-saga/effects';
import { loadItensNotaEntrada, loadEtapas, loadMovimentacoes } from './movimentacoes/saga';
import { MovimentacoesTypes } from './movimentacoes/types';
import { loadItensNotaSecundarias, loadMovimentacoesSaida } from './solicitacoesRetorno/saga';
import { SolicitacoesRetornoTypes } from './solicitacoesRetorno/types';
import { AuthTypes } from './auth/types';
import { forgotPassword, login, updateToken, logout, updateProfile } from './auth/saga';
import { loadEstoque } from './estoque/saga';
import { EstoqueTypes } from './estoque/types';
import {
  criarTransp,
  loadTransp,
  selectTransp,
  selectTransportadoraParceira,
  verificarTransp,
} from './transportadoras/saga';
import { TransportadorasTypes } from './transportadoras/types';
import { EstoqueCartTypes } from './estoqueCart/types';
import { loadPagadores } from './estoqueCart/saga';
import { SolicitacaoRetornoTypes } from './solicitacaoRetorno/types';
import { loadSolicitacaoRetorno } from './solicitacaoRetorno/saga';
import { SolicitacoesRetornoItensNotaTypes } from './solicitacoesRetornoItensNota/types';
import { loadRequestItensNota } from './solicitacoesRetornoItensNota/saga';
import { GestaoAgendamentoTypes } from './gestaoAgendamento/types';
import { loadGestaoAgendamento } from './gestaoAgendamento/saga';
import { MotoristaTypes } from './motorista/types';
import { FornecedorTypes } from './fornecedor/types';
import { loadMotorista, loadDetalhesMotorista } from './motorista/saga';
import { ProdutosTypes } from './produtos/types';
import { loadProdutos } from './produtos/saga';
import { IActionTypesColetaNoCd } from './coletaNoCd/types';
import { loadColetaNoCd } from './coletaNoCd/saga';
import { PagadorArmazenagemTypes } from './pagadorArmazenagem/types';
import { loadPagArmazenagem } from './pagadorArmazenagem/saga';

import { AgendamentosTypes } from './agendamentos/types';
import { loadAgendamentos } from './agendamentos/saga';
import { ConsultaAgendamentosTypes } from './consultaAgendamentos/types';
import { loadConsultaAgendamentos } from './consultaAgendamentos/saga';

import { loadFornecedor } from './fornecedor/saga';
import { loadCentrosDistribuicao } from './centrosDistribuicao/saga';
import { CentrosDistribuicaoTypes } from './centrosDistribuicao/types';
import { TomadoresTransportadoraTypes } from './tomadoresTransportadora/types';
import { loadTomadoresTransportadora } from './tomadoresTransportadora/saga';
import { PedidoEntregaTypes } from './pedidoEntrega/types';
import { loadPedidoEntrega } from './pedidoEntrega/saga';
import { CidadeOrigemTypes } from './cidadeOrigem/types';
import { loadCidadeOrigem } from './cidadeOrigem/saga';
import { EntregaNoCdTypes } from './entregaNoCd/types';
import { loadEntregaNoCD } from './entregaNoCd/saga';
import { ListarVeiculosTypes } from './listarVeiculos/types';
import { loadListaVeiculos } from './listarVeiculos/saga';
import { loadOrdemCarga } from './ordemCarga/saga';
import { OrdemCargaTypes } from './ordemCarga/types';
import { EstadoCidadeTypes } from './estadoCidade/types';
import { loadCidades, loadEstados } from './estadoCidade/saga';
import { CriaAgendamentoTypes } from './criaAgendamento/types';
import { loadCriaAgendamento } from './criaAgendamento/saga';
import { DataHoraordemDeCargaTypes } from './dataHoraordemDeCarga/types';
import { loadDataHoraordemDeCarga } from './dataHoraordemDeCarga/saga';
import { DetalheVeiculoTypes } from './detalheVeiculo/types';
import { loadDetalheVeiculo } from './detalheVeiculo/saga';
import { PlataformaTypes } from './plataforma/types';
import { loadPlataforma } from './plataforma/saga';
import { EstadoOrigemTypes } from './estadoOrigem/types';
import { loadEstadoOrigem } from './estadoOrigem/saga';
import { OrdemCargaPageTypes } from './ordemCargaPage/types';
import { loadOrdemCargaPage } from './ordemCargaPage/saga';
import { AtendimentosTypes } from './atendimentos/types';
import { loadAtendimentos } from './atendimentos/saga';
import { CriarAtendimentoTypes } from './criarAtendimento/types';
import { loadNotas } from './criarAtendimento/saga';
import { AtendimentosMensagensTypes } from './sendMenssages/types';
import { sendMenssageReq } from './sendMenssages/saga';
import { AgrupamentosTypes } from './agrupamento/types';
import { loadAgrupamentos } from './agrupamento/saga';
import { SemaphoreTypes } from './semaphore/types';
import { loadSemaphore } from './semaphore/saga';
import { KpiACTypes } from './kpiAC/types';
import { sagaKpiAC } from './kpiAC/saga';
import { KpiEAITypes } from './kpiEAI/types';
import { sagaKpiEAI } from './kpiEAI/saga';
import { KpiEAETypes } from './kpiEAE/types';
import { sagaKpiEAE } from './kpiEAE/saga';
import { KpiSATypes } from './kpiSA/types';
import { sagaKpiSA } from './kpiSA/saga';
import { KpiSETypes } from './kpiSE/types';
import { sagaKpiSE } from './kpiSE/saga';
import { OcorrenciaTypes } from './ocorrencia/types';
import { loadOcorrencia, updateOcorrencia } from './ocorrencia/saga';
import { ProgressBarSLATypes } from './progressBarSLA/types';
import { loadProgressSLA } from './progressBarSLA/saga';
import { NotificationsTypes } from './notifications/types';
import { loadNotifications, loadMessageRead } from './notifications/saga';
import { loadAttachments } from './downloadAttachments/saga';
import { DownloadAttachmentsTypes } from './downloadAttachments/types';

import { loadDashSla } from './dashSlaAtendimento/saga';
import { dashSlaTypes } from './dashSlaAtendimento/types';

import { loadTracking } from './tracking/saga';
import { TrackingTypes } from './tracking/types';

import { loadBlackList } from './blackList/saga';
import { BlackListTypes } from './blackList/types';

import { loadCargaDescarga } from './cargaDescarga/saga';
import { CargaDescargaTypes } from './cargaDescarga/types';

import { loadHorariosDisponiveis } from './horariosDisponiveis/saga';
import { HorariosDisponiveisTypes } from './horariosDisponiveis/types';

import { loadDetalhesOrdemCarga } from './detalhesOrdemCarga/saga';
import { DetalhesOrdemCargaTypes } from './detalhesOrdemCarga/types';

import { loadDepositante } from './depositante/saga';
import { DepositanteTypes } from './depositante/types';

export default function* rootSaga() {
  return yield* [
    takeLatest(AuthTypes.LOGIN_REQUEST, login),
    takeLatest(AuthTypes.UPDATE_REQUEST, updateToken),
    takeLatest(AuthTypes.PASSWORD_REQUEST, forgotPassword),
    takeLatest(AuthTypes.LOGOUT_REQUEST, logout),
    takeLatest(AuthTypes.UPDATE_PROFILE, updateProfile),
    takeLatest(MovimentacoesTypes.LOAD_REQUEST, loadMovimentacoes),
    takeLatest(MovimentacoesTypes.ETAPA_REQUEST, loadEtapas),
    takeLatest(MovimentacoesTypes.ITENS_NOTA_REQUEST_ENTRADA, loadItensNotaEntrada),
    takeLatest(SolicitacoesRetornoTypes.LOAD_REQUEST, loadMovimentacoesSaida),
    takeLatest(SolicitacoesRetornoItensNotaTypes.ITENS_NOTA_REQUEST, loadRequestItensNota),
    takeLatest(SolicitacoesRetornoTypes.ITENS_NOTA_SECUNDARIAS_REQUEST, loadItensNotaSecundarias),
    takeLatest(EstoqueTypes.LOAD_REQUEST, loadEstoque),
    takeLatest(EstoqueCartTypes.PAGADORES_REQUEST, loadPagadores),
    takeLatest(ProdutosTypes.LOAD_REQUEST, loadProdutos),
    takeLatest(IActionTypesColetaNoCd.LOAD_REQUEST, loadColetaNoCd),
    takeLatest(EntregaNoCdTypes.LOAD_REQUEST, loadEntregaNoCD),
    takeLatest(GestaoAgendamentoTypes.LOAD_REQUEST, loadGestaoAgendamento),
    takeLatest(TransportadorasTypes.LOAD_REQUEST, loadTransp),
    takeLatest(TransportadorasTypes.SELECT_REQUEST, selectTransp),
    takeLatest(
      TransportadorasTypes.SELECT_TRANSPORTADORA_PARCEIRA_REQUEST,
      selectTransportadoraParceira
    ),
    takeLatest(TransportadorasTypes.CRIAR_TRANSPORT_REQUEST, criarTransp),
    takeLatest(TransportadorasTypes.VERIFICAR_TRANSPORT_REQUEST, verificarTransp),
    takeLatest(SolicitacaoRetornoTypes.LOAD_SOLICITACAO_REQUEST, loadSolicitacaoRetorno),
    takeLatest(MotoristaTypes.LOAD_REQUEST, loadMotorista),
    takeLatest(MotoristaTypes.LOAD_DETALHES_REQUEST, loadDetalhesMotorista),
    takeLatest(FornecedorTypes.LOAD_REQUEST, loadFornecedor),
    takeLatest(CentrosDistribuicaoTypes.LOAD_REQUEST, loadCentrosDistribuicao),
    takeLatest(PagadorArmazenagemTypes.LOAD_REQUEST, loadPagArmazenagem),
    takeLatest(AgendamentosTypes.LOAD_REQUEST, loadAgendamentos),
    takeLatest(TomadoresTransportadoraTypes.LOAD_REQUEST, loadTomadoresTransportadora),
    takeLatest(CidadeOrigemTypes.LOAD_REQUEST, loadCidadeOrigem),
    takeLatest(EstadoOrigemTypes.LOAD_REQUEST, loadEstadoOrigem),
    takeLatest(PedidoEntregaTypes.LOAD_REQUEST, loadPedidoEntrega),
    takeLatest(ListarVeiculosTypes.LOAD_REQUEST, loadListaVeiculos),
    takeLatest(OrdemCargaTypes.LOAD_REQUEST, loadOrdemCarga),
    takeLatest(OrdemCargaPageTypes.LOAD_REQUEST, loadOrdemCargaPage),
    takeLatest(EstadoCidadeTypes.LOAD_ESTADO_REQUEST, loadEstados),
    takeLatest(EstadoCidadeTypes.LOAD_CIDADE_REQUEST, loadCidades),
    takeLatest(CriaAgendamentoTypes.LOAD_REQUEST, loadCriaAgendamento),
    takeLatest(DataHoraordemDeCargaTypes.LOAD_REQUEST, loadDataHoraordemDeCarga),
    takeLatest(DetalheVeiculoTypes.LOAD_REQUEST, loadDetalheVeiculo),
    takeLatest(PlataformaTypes.LOAD_REQUEST, loadPlataforma),
    takeLatest(AtendimentosTypes.LOAD_REQUEST, loadAtendimentos),
    takeLatest(CriarAtendimentoTypes.LOAD_REQUEST, loadNotas),
    takeLatest(AtendimentosMensagensTypes.SEND_MENSSAGE_REQUESTE, sendMenssageReq),
    takeLatest(ConsultaAgendamentosTypes.LOAD_REQUEST, loadConsultaAgendamentos),
    takeLatest(AgrupamentosTypes.LOAD_REQUEST, loadAgrupamentos),
    takeLatest(SemaphoreTypes.LOAD_REQUEST, loadSemaphore),
    takeLatest(KpiACTypes.LOAD_REQUEST, sagaKpiAC),
    takeLatest(KpiEAITypes.LOAD_REQUEST, sagaKpiEAI),
    takeLatest(KpiEAETypes.LOAD_REQUEST, sagaKpiEAE),
    takeLatest(KpiSATypes.LOAD_REQUEST, sagaKpiSA),
    takeLatest(KpiSETypes.LOAD_REQUEST, sagaKpiSE),
    takeLatest(OcorrenciaTypes.LOAD_REQUEST, loadOcorrencia),
    takeLatest(OcorrenciaTypes.LOAD_REQUEST_UPDATE, updateOcorrencia),
    takeLatest(ProgressBarSLATypes.LOAD_REQUEST, loadProgressSLA),
    takeLatest(NotificationsTypes.LOAD_NOTIFICATIONS_REQUEST, loadNotifications),
    takeLatest(NotificationsTypes.LOAD_MESSAGE_READ, loadMessageRead),
    takeLatest(DownloadAttachmentsTypes.LOAD_DOWNLOADATTACHMENTS_REQUEST, loadAttachments),
    takeLatest(dashSlaTypes.LOAD_RESUMO_ATENDIMENTO_REQUEST, loadDashSla),
    takeLatest(TrackingTypes.LOAD_TRACKING_REQUEST, loadTracking),
    takeLatest(BlackListTypes.LOAD_REQUEST, loadBlackList),
    takeLatest(CargaDescargaTypes.LOAD_REQUEST_CARGA_DESCARGA, loadCargaDescarga),
    takeLatest(HorariosDisponiveisTypes.LOAD_REQUEST, loadHorariosDisponiveis),
    takeLatest(DetalhesOrdemCargaTypes.LOAD_REQUEST, loadDetalhesOrdemCarga),
    takeLatest(DepositanteTypes.LOAD_REQUEST, loadDepositante),
  ];
}
